import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import './index.scss';
//  text 展开折叠值
//  otherText 按钮值， 默认展开关闭
//  otherText 按钮其他值
//  onClick 点击事件
//  offsetHeight < scrollHeight || offsetWidth < scrollWidth 判断超出显示，不超出不显示
const ExpandCollapseText = (porps: any) => {
  let { text, onClick, otherText, isShow, className, rowNum } = porps;
  let TextDom = useRef(null);
  const [offsetHeight, setOffsetHeight] = useState(0);
  const [scrollHeight, setscrollHeight] = useState(0);
  const [windowSize, setWindowSize] = useState<any>(null);
  useEffect(() => {
    window.addEventListener('resize', () => setWindowSize(window.innerWidth));
    return () => {
      window.removeEventListener('resize', () =>
        setWindowSize(window.innerWidth),
      );
    };
  }, []);
  // 因为有响应式,所以要监听屏幕宽度， 重新判断高度
  useLayoutEffect(() => {
    setOffsetHeight(TextDom?.current?.offsetHeight);
    setscrollHeight(TextDom?.current?.scrollHeight);
  }, [windowSize, text]);
  return (
    <div className="dbg-expand-collapse">
      <div
        className={`${
          className ? className : null
        } dbg-expand-collapse-text-show ${
          isShow ? '' : 'dbg-expand-collapse-text-noshow'
        }`}
        style={{ WebkitLineClamp: rowNum ? rowNum : 2 }}
        ref={TextDom}
        id="TextDom"
      >
        {scrollHeight > offsetHeight ? (
          <label
            className="dbg-expand-collapse-text-btn"
            htmlFor="exp"
            onClick={onClick}
          >
            {otherText ? otherText : isShow ? 'Less All' : 'Show All'}
          </label>
        ) : isShow ? (
          <label
            className="dbg-expand-collapse-text-btn"
            htmlFor="exp"
            onClick={onClick}
          >
            Less All
          </label>
        ) : null}
        <span className='dbg-expand-collapse-context' dangerouslySetInnerHTML={{__html:text}}></span>
      </div>
    </div>
  );
};

export default ExpandCollapseText;
